import type {
  CurrentUserGetPayload,
  UseGetCurrentUserOptions,
} from "./current-user.type";
import type { ApiError } from "@/services/api";

import { useQuery } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useGetCurrentUser = (options?: UseGetCurrentUserOptions) => {
  const { data, ...queryResult } = useQuery<CurrentUserGetPayload, ApiError>({
    queryKey: ["users", "current", "get"],
    queryFn: () => client.users.user(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    ...options,
  });

  return {
    ...queryResult,
    currentUser: data?.data?.data,
  };
};
